/**
 * Where a visitor came from, for #monitor-users: the page that led to the
 * sign-up form, without query or fragment (they can carry tokens and emails),
 * or "direct". `document.referrer` is the page that opened the app, also
 * through the in-app navigation from the sign-in page.
 */
export function signUpSource(referrer = document.referrer): string {
  if (!referrer) return "direct";
  try {
    const { origin, pathname } = new URL(referrer);
    return `${origin}${pathname}`.slice(0, 300);
  } catch {
    return "direct";
  }
}
